import '@babel/polyfill';
import 'raf/polyfill';
import ReactOnRails from 'react-on-rails';

import 'react-phone-number-input/style.css';

import '../application/App.scss';

import Header from '../shared/header/Header';
import Banner from '../shared/banner/Banner';
import Footer from '../shared/footer/Footer';
import ResendPin from '../application/resend_pin/ResendPin';

ReactOnRails.register({
  Header,
  Banner,
  Footer,
  ResendPin
});
